import { render, staticRenderFns } from "./SetIconBtn.vue?vue&type=template&id=18e14654&scoped=true"
import script from "./SetIconBtn.vue?vue&type=script&lang=js"
export * from "./SetIconBtn.vue?vue&type=script&lang=js"
import style0 from "./SetIconBtn.vue?vue&type=style&index=0&id=18e14654&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18e14654",
  null
  
)

export default component.exports